
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { ThemeContext } from '../theme';

const NotFound: React.FC = () => {
    // Theme
    const { isDarkMode, toggleDarkMode, colors } = useContext(ThemeContext)!;
    const textColor: string = isDarkMode ? "white" : "black";

    return (
        <div className={`${colors.bgSecondaryColor} flex flex-col items-center justify-center min-h-[80vh] px-6 text-center`}>
            <h1 className={`text-9xl font-black ${colors.inputTextColor}`}>404</h1>

            <div className="absolute">
                <h2 className={`text-2xl font-bold sm:text-4xl mt-4 ${colors.textColor}`}>
                    Lost in space?
                </h2>
                <p className={`mt-4 text-gray-500 dark:text-gray-400 ${colors.textColor}`}>
                    We can't find the page you're looking for.
                </p>

                <Link
                    to="/"
                    className={`inline-block px-8 py-3 mt-8 text-sm font-medium ${colors.textColor} ${colors.primaryColor} rounded hover:scale-105 transition-all duration-300 focus:outline-none focus:ring`}
                >
                    Go Back Home
                </Link>
            </div>
        </div>
    );
};

export default NotFound;
